module.exports = {EU_PersonalLiabilityCov:'Agent Binding authority up to 2,000,000. Underwriting approval required for higher limits.'}